import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Toast, ToastsManager } from 'ng2-toastr';

import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { CommonService } from '../../service/common.service';
import { CompanyService } from '../../service/company.service';
import { ProjectService } from '../../service/project.service';
import { CloudService } from '../../service/cloud.service';

@Component({
  selector: 'add-company-modal',
  templateUrl: './addCompanyModal.component.html',
})
export class AddCompanyModalComponent implements OnInit {
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private projectService: ProjectService,
    private companyService: CompanyService,
    private commonService: CommonService,
    private cloudService: CloudService,
    private toastr: ToastsManager,
    vRef: ViewContainerRef
  ) {
    this.toastr.setRootViewContainerRef(vRef);
  }

  @ViewChild('companyModal') modal: ModalComponent;

  companyId: any;

  projectId: any;

  fieldName: string;

  selectedWidth = 100;

  selectedHeight = 100;

  img: string;

  inputElement: any;

  //
  // Define the MIME type that we convert images to and upload them as.
  //
  imageMimeType = 'image/png';

  ngOnInit() {}

  onUpdate(event, dimension) {
    if (dimension === 'width') {
      this.selectedWidth = event.target.value;
    } else if (dimension === 'height') {
      this.selectedHeight = event.target.value;
    }
    this.fileChange(this.inputElement);
  }

  // This is called when the user selects new files from the upload button
  fileChange(input) {
    this.inputElement = input;
    const fileExtenstion = input.files[0].name.split('.')[1].toLowerCase();
    if (fileExtenstion === 'png' || fileExtenstion === 'jpg' || fileExtenstion === 'jpeg') {
      // console.log(`Reading file: ${input.files[0].name}`);
      this.readFiles(input.files);
    } else {
      // console.error(`Invalid file extension: ${fileExtenstion}`);
      this.img = null;
    }
  }

  readFile(file, reader, callback) {
    // Set a callback funtion to fire after the file is fully loaded
    // console.log('[readFile] Setting onload handler');
    reader.onload = () => {
      // console.log('[readFile] Inside callback');
      // callback with the results
      callback(reader.result);
    };
    // reader.onerror = () => console.error(`Error occurred loading file`);

    // Read the file
    reader.readAsDataURL(file);
  }

  readFiles(files, index = 0) {
    // Create the file reader
    const reader = new FileReader();

    // If there is a file
    if (files[index]) {
      // Start reading this file
      this.readFile(files[index], reader, (result) => {
        // Create an img element and add the image file data to it
        const img = document.createElement('img');
        img.src = result;

        // Send this img to the resize function (and wait for callback)
        this.resize(img, this.selectedWidth, this.selectedHeight, (resizedImage) => {
          // This is the file you want to upload. (either as a
          // base64 string or img.src = resizedImage if you prefer a file).
          this.img = resizedImage;

          // Read the next file;
          this.readFiles(files, index + 1);
        });
      });
    } else {
      // When all files are done This forces a change detection
      this.changeDetectorRef.detectChanges();
    }
  }

  resize(img, MAX_WIDTH: number, MAX_HEIGHT: number, callback) {
    // This will wait until the img is loaded before calling this function
    return (img.onload = () => {
      // Set the WxH to fit the Max values (but maintain proportions)
      const width = MAX_WIDTH;
      const height = MAX_HEIGHT;

      // create a canvas object
      const canvas = document.createElement('canvas');

      // Set the canvas to the new calculated dimensions
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(img, 0, 0, width, height);

      // Get this encoded as a png. We could also request "jpeg" (not "jpg").
      const dataUrl = canvas.toDataURL(this.imageMimeType);

      // callback with the results
      callback(dataUrl);
    });
  }

  open(id: string, fieldName: string): void {
    if (fieldName === 'company') {
      // to update company image
      this.fieldName = fieldName;
      this.companyId = id;
    } else if (fieldName === 'project') {
      // to update project image, as of now it is not in used(can be used in v2 version)
      this.fieldName = fieldName;
      this.projectId = id;
    }
    this.modal.open();
  }

  //-------------------------------------------------------------------------------------------------

  uploadFile(signedRequestUrl: string, fileDownloadUrl: string) {
    //    console.log(`AWS URL for upload: ${signedRequestUrl}`);

    this.cloudService.uploadDataUri(signedRequestUrl, this.img).subscribe(
      (response) => {
        //      console.log(`Response from AWS: ${response} or ${JSON.stringify(response)}`);
        if (response.status >= 200 && response.status < 300) {
          // to update company image
          const data = {
            fieldName: 'logoUrl',
            logoUrl: fileDownloadUrl,
          };
          const image = { image: this.img };
          this.companyService.updateCompany(this.companyId, data).subscribe(
            (uploadResult) => {
              if (uploadResult.messageId === 200) {
                this.toastr.success(uploadResult.message, 'Success!', { toastLife: 1000 });
                //
                // Notify other components (like the Home page) that the company has been modified so they
                // can take actions like redisplaying the companies.
                //
                this.commonService.notifyOther({ option: 'company_add', value: image });
                this.modal.close();
              } else if (uploadResult.messageId === 401) {
                // TODO: Can the API still cause this? (And 401 is the wrong code.)
                this.toastr.error(uploadResult.message, 'Error!');
              } else {
              }
            },
            (err) => {
              this.toastr.error('Something is wrong!', 'Oops!');
            }
          );
        }
      },
      (err) => {
        // TODO: Need to fill in this error handler
        //      console.error(`Error during upload: ${JSON.stringify(err, null, 2)}`);
      }
    );
  }

  //-------------------------------------------------------------------------------------------------

  getSignedRequest(fileType: string) {
    return new Promise(async (resolve, reject) => {
      this.companyService.getLogoUploadUrl(this.companyId, fileType).subscribe(
        (uploadData) => {
          //        console.log(JSON.stringify(uploadData, null, 2));
          return resolve(uploadData);
        },
        (err) => {
          //        console.log(`Error occurred while getting logo upload url: ${err.toString()}`);
          return reject(err);
        }
      );
    });
  }

  //-------------------------------------------------------------------------------------------------

  async onSubmit() {
    if (this.img !== undefined) {
      if (this.fieldName === 'company') {
        //
        // Get the URL where we need to upload the image.
        //
        let uploadData;
        try {
          //
          // The image has been resized and processed into the "this.img" variable as a base64-encoded
          // string with the MIME type included. This is what we upload, not the original file that was specified.
          // We have to tell the cloud what kind of data we are going to upload.
          //
          uploadData = await this.getSignedRequest(this.imageMimeType);
        } catch (ex) {
          //          console.error(`An error occurred while getting the signed request: ${ex.toString()}`);
          this.toastr.error('An error occurred while uploading the logo.', 'Error');
          return;
        }

        //
        // Once we have the URL, we can then upload the file to the cloud.
        //
        this.uploadFile(uploadData.signedRequest, uploadData.url);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/addCompanyModal/addCompanyModal.component.ts